import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { DollarSign, FileText, HelpCircle, TrendingUp } from 'lucide-react';
const painPoints = [{
  icon: DollarSign,
  title: 'Creo que no califico por mis ingresos',
  description: 'Muchos latinos ganan lo suficiente pero no saben cómo demostrarlo correctamente al banco.'
}, {
  icon: FileText,
  title: 'No sé si mi estatus migratorio me permite comprar',
  description: 'El ITIN es válido para comprar casa. Te explicamos qué bancos lo aceptan y cómo aplicar.'
}, {
  icon: HelpCircle,
  title: 'No entiendo los préstamos ni los términos en inglés',
  description: 'Traducimos y simplificamos todo el proceso para que tomes decisiones con confianza.'
}, {
  icon: TrendingUp,
  title: 'Me da miedo el interés alto y perder dinero',
  description: 'Aprende a evaluar si es el momento correcto para ti y cómo proteger tu inversión.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function PainPointsSection() {
  return <section className="py-24 bg-dark relative border-t border-white/5 pt-[20px] pb-[20px]" data-id="element-102">
      <div className="container mx-auto px-6" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-104">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl mb-6" data-id="element-105">
            ¿Te Identificas con Alguna de Estas Situaciones?
          </h2>
          <p className="text-muted text-lg" data-id="element-106">
            No estás solo. Miles de familias hispanas sienten lo mismo antes de
            dar el primer paso hacia su casa propia.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto" data-id="element-107">
          {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="bg-dark-card border border-white/5 rounded-xl p-8 transition-all duration-300 gold-glow-hover group pt-[10px] pb-[10px]" data-id="element-108">
              <div className="w-14 h-14 rounded-full bg-gold/10 flex items-center justify-center mb-6 group-hover:bg-gold/20 transition-colors" data-id="element-109">
                <point.icon className="w-7 h-7 text-gold" data-id="element-110" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white group-hover:text-gold transition-colors" data-id="element-111">
                "{point.title}"
              </h3>
              <p className="text-muted leading-relaxed" data-id="element-112">{point.description}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}